import { all } from "redux-saga/effects";
import { authSagas } from "./Auth/LoginSaga";
export default function* rootSaga() {
  yield all([authSagas()]);
}
